// Live app store links for STON.FIT
export const APP_STORE_URL = 'https://apps.apple.com/in/app/ston-fit/id6760261152';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.stonfit.app';
